import { http } from './client';
import type {
  Me, Profile, SessionEntry, PlayerSearchResult, NetworkStats, AuditEntry,
  PlayerLookupResult
} from '@/types/api';

// Re-exports damit Components nur '@/api' importieren muessen
export type { Me, Profile, SessionEntry, PlayerSearchResult, NetworkStats, AuditEntry,
              PlayerLookupResult };

export const authApi = {
  /** Code aus /verify einloesen → Server setzt 30d Session-Cookie. */
  redeem: (code: string) => http.post<Me>('/api/auth/redeem', { code }),
  /** Gibt den eingeloggten User zurueck oder wirft bei abgelaufener Session. */
  me:     () => http.get<Me>('/api/auth/me'),
  logout: () => http.post<void>('/api/auth/logout')
};

export const profileApi = {
  me:           () => http.get<Profile>('/api/profile'),
  sessions:     () => http.get<SessionEntry[]>('/api/profile/sessions'),
  revokeSession:(token: string) => http.delete<void>(`/api/profile/sessions/${encodeURIComponent(token)}`),
  revokeAllOther: () => http.post<void>('/api/profile/sessions/revoke-other'),
  removeFriend: (uuid: string) => http.delete<void>(`/api/profile/friends/${encodeURIComponent(uuid)}`),
  acceptRequest:(uuid: string) => http.post<void>(`/api/profile/friend-requests/${encodeURIComponent(uuid)}/accept`),
  declineRequest:(uuid: string) => http.post<void>(`/api/profile/friend-requests/${encodeURIComponent(uuid)}/decline`)
};

/** Spieler-Resolver fuer den Shop-Geschenk-Flow. */
export const playersApi = {
  lookup: (name: string) =>
    http.get<PlayerLookupResult>(`/api/players/lookup?name=${encodeURIComponent(name)}`)
};

export const adminApi = {
  stats:       () => http.get<NetworkStats>('/api/admin/stats'),
  searchPlayers: (q: string) => http.get<PlayerSearchResult[]>(`/api/admin/players?q=${encodeURIComponent(q)}`),
  player:      (uuid: string) => http.get<Profile>(`/api/admin/players/${encodeURIComponent(uuid)}`),
  ban:         (uuid: string, payload: { reason: string; durationSeconds: number | null }) =>
                 http.post<void>(`/api/admin/players/${encodeURIComponent(uuid)}/ban`, payload),
  unban:       (uuid: string, reason: string) =>
                 http.post<void>(`/api/admin/players/${encodeURIComponent(uuid)}/unban`, { reason }),
  giveCoins:   (uuid: string, amount: number, reason: string) =>
                 http.post<void>(`/api/admin/players/${encodeURIComponent(uuid)}/coins`, { amount, reason }),
  giveCrates:  (uuid: string, crateKey: string, amount: number) =>
                 http.post<void>(`/api/admin/players/${encodeURIComponent(uuid)}/crates`, { crateKey, amount }),
  retryWin:    (winId: number) => http.post<void>(`/api/admin/wins/${winId}/retry`),
  refundWin:   (winId: number) => http.post<void>(`/api/admin/wins/${winId}/refund`),
  bansList:    () => http.get<{ uuid: string; name: string; bannedBy: string; reason: string; createdAt: number; expiresAt: number | null }[]>('/api/admin/bans'),
  audit:       (limit = 100) => http.get<AuditEntry[]>(`/api/admin/audit?limit=${limit}`),
  broadcast:   (message: string) => http.post<void>('/api/admin/broadcast', { message })
};
